module.exports = __webpack_public_path__ + "media/SAF-500-2_Ares_Ransomware_2025.9dd9e0a9.mp4";